@if (depth >= maxDepth) {
  <span class="text-slate-500 small" [class.small]="embedMode">{{
    'knowledgeSetup.recursionLimit' | translate
  }}</span>
} @else if (isPrimitive(value)) {
  <span
    class="text-slate-800 whitespace-pre-wrap break-words"
    [class.small]="embedMode"
    >{{ value === null || value === undefined ? '—' : value }}</span
  >
} @else if (isArrayValue(value)) {
  @if (value.length === 0) {
    <span class="text-slate-400 small" [class.small]="embedMode">[]</span>
  } @else {
    <ul class="m-0 ps-4 space-y-1 list-disc text-slate-700" [class.small]="embedMode">
      @for (item of value; track $index) {
        <li class="break-words">
          @if (isRecord(item)) {
            <app-educational-content-value-block
              [value]="item"
              [depth]="depth + 1"
              [embedMode]="embedMode" />
          } @else {
            {{ itemLabel(item) }}
          }
        </li>
      }
    </ul>
  }
} @else if (isRecord(value)) {
  <dl class="edu-value-dl m-0 space-y-2">
    @for (key of objectKeys(value); track key) {
      <div class="rounded-lg border border-slate-100 bg-slate-50/80 px-2 py-2">
        <dt [ngClass]="headingClass()">{{ key | eduFieldLabel }}</dt>
        <dd class="m-0 mt-1">
          <app-educational-content-value-block
            [value]="value[key]"
            [depth]="depth + 1"
            [embedMode]="embedMode" />
        </dd>
      </div>
    }
  </dl>
} @else {
  <span class="text-slate-600">{{ itemLabel(value) }}</span>
}
